export default class SqColorIconHelper {
  setIcon(icon?: string) {
    if (icon === 'twitter') {
      return 'x'
    }
    return icon
  }

  setColor(color?: string) {
    if (color === 'twitter') {
      return 'x'
    }
    return color
  }
}
